"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharingFilter = exports.FilterGroupType = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
var FilterGroupType;
(function (FilterGroupType) {
    FilterGroupType[FilterGroupType["All"] = 0] = "All";
    FilterGroupType[FilterGroupType["FoundedGroups"] = 1] = "FoundedGroups";
    FilterGroupType[FilterGroupType["ParticipatingGroups"] = 2] = "ParticipatingGroups";
})(FilterGroupType || (exports.FilterGroupType = FilterGroupType = {}));
exports.sharingFilter = [
    {
        type: bridge_schema_1.FilterCategoryType.ResourceGroup,
        title: 'Filter',
        placeholder: '',
        emptyPlaceholder: '',
        items: [
            {
                identifier: FilterGroupType.All,
                type: bridge_schema_1.FilterItemType.Radio,
                title: i18n_1.Strings.library.filters.allGroupsMobile,
                isSelected: true,
            },
            {
                identifier: FilterGroupType.FoundedGroups,
                type: bridge_schema_1.FilterItemType.Radio,
                title: i18n_1.Strings.library.filters.myGroups,
            },
            {
                identifier: FilterGroupType.ParticipatingGroups,
                type: bridge_schema_1.FilterItemType.Radio,
                title: i18n_1.Strings.library.filters.groupsIBelongTo,
            },
        ],
    },
];
